/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
export class QPChatEntity extends Entity {
  id: string = '';
  name: string | null = null;
  static override key = 'QPChat';
  static override schema = {};
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'QPChat' in input
    ) {
      const { QPChat: wrapped, ...rest } = input as {
        QPChat: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}